module.exports = __webpack_public_path__ + "static/media/header3a11710b7075c97dea8ee9dcb20825d3.webp";